import { Component, Input, Optional, SkipSelf, Host, AfterViewInit, ChangeDetectorRef, NgZone, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Router, NavigationExtras, UrlTree } from '@angular/router';
import { PageSectionContainerComponent } from '../page-section-container/page-section-container.component';
import { HyphenatePipe } from '../../pipes/hyphenate';
import { Clipboard } from '@angular/cdk/clipboard';
import { FocusMonitor } from '@angular/cdk/a11y';


@Component({
  selector: 'dls-page-section',
  templateUrl: './page-section.component.html',
})
export class PageSectionComponent implements AfterViewInit, OnDestroy {

  @ViewChild('titleReference') private titleRef: ElementRef<HTMLElement>;

  public sectionFragmentID: string;
  public isMouseOver: boolean;
  public isFocus: boolean;

  @Input() title: string;
  @Input() sectionSpacer: 0 | 16 | 24 | 48;
  constructor(
    private _router: Router,
    @Optional() @Host() @SkipSelf() private _pageSectionContainerRef: PageSectionContainerComponent,
    private _cdr: ChangeDetectorRef,
    private _hyphenate: HyphenatePipe,
    private _clipboard: Clipboard,
    private _focusMonitor: FocusMonitor,
    private _ngZone: NgZone
  ) {
    this.sectionSpacer = 48;
    this.sectionFragmentID = null;
    this.isMouseOver = false;
    this.isFocus = false;
  }

  ngAfterViewInit(): void {
    if (this._pageSectionContainerRef && this._pageSectionContainerRef.headline && this.title) {

      // Create fragment with Page Section headline and Section Title
      this.sectionFragmentID = this._hyphenate
        .transform(`${this._pageSectionContainerRef.headline}-${this.title}`)
        .toLocaleLowerCase();

      this._cdr.detectChanges();

      this._focusMonitor
        .monitor(this.titleRef.nativeElement, true)
        .subscribe(
          origin => {
            // To execute focus event with in Angular
            this._ngZone.run(() => {
              this.isFocus = origin !== null;
            });
          });
    }
  }

  ngOnDestroy(): void {
    if (this._pageSectionContainerRef && this._pageSectionContainerRef.headline && this.title) {
      this._focusMonitor.stopMonitoring(this.titleRef.nativeElement);
    }
  }

  // Copy the current url with page section fragment
  public copyLink(): void {
    const currentUrlTree: UrlTree = this._router.createUrlTree([], <NavigationExtras>{ fragment: this.sectionFragmentID });

    // Sets section fragment to the URL
    this._router.navigateByUrl(currentUrlTree);

    // Copy the current URL with fragment to clipboard
    this._clipboard.copy(`${window.location.origin}${window.location.pathname}#${this.sectionFragmentID}`);
  }
}
